import React, { useEffect, useState } from "react";
import {
  Input,
  Label,
  Button,
  FormFeedback,
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Alert,
} from "reactstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { NAME_MAXLENGTH, DESCRIPTION_MAXLENGTH } from "@constants/constants";
import Spinners from "@components/custom-table/Spinner";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PHONE_NUMBER_MAXLENGTH } from "@constants/constants";
import Select from "react-select";
import { getAuthorList } from "../../author/services/author-services";
import {
  addMedia,
  editMedia,
  getMedia,
  getMediaCount,
  getPresignedUrl,
} from "../services/media-services";
import { resetError, resetState } from "../controller/media-slice";
import { MediaTypes } from "@constants/constants";
import { getVoiceList } from "../../voices/services/voice-services";
import { getGenreList } from "../../genre/services/genre-services";
import { mediaSchema } from "@helpers/validation-schema";
import { purchaseTypes, types } from "@constants/constants";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { url } from "@constants/url-constants";
import EpisodeForm from "../../../components/episode-form-repeater/episode-form";
import ViewModal from "../../../components/custom-table/ViewModel";
import { mediaUpdateSchema } from "../../../helpers/validation-schema";
import { Contents } from "../../content-units/ui";
import CustomLabel from "../../../components/CustomLabel";
import ContentFormRepeater from "../../../components/description-form-repeater/description-form";

export const AddMedia = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const route = pathname.split("/")[2];
  const mediaId = pathname.split("/")[3];
  const success = useSelector((state) => state.media.success);
  const media = useSelector((state) => state.media.medias);
  const loading = useSelector((state) => state.media.loading);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pageQuery = parseInt(searchParams.get("current_page"));
  const successMessage = useSelector((state) => state.media.successMessage);
  const errorMessage = useSelector((state) => state.media.errorMessage);
  const authors = useSelector((state) => state.author.authors);
  const voices = useSelector((state) => state.voice.voices);
  const genres = useSelector((state) => state.genre.genres);
  const [selectedPurchaseType, setSelectedPurchaseType] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [viewModel, setViewModel] = useState(false);
  const [viewImageUrl, setViewImageUrl] = useState("");
  const options = {
    mediaOptions: MediaTypes?.map((row) => ({
      value: row.id,
      label: row.name,
    })),

    authOptions:
      [...(authors || [])]
        ?.sort((a) => (a.deleted_at === null ? -1 : 1))
        ?.map((row) => ({
          value: row._id,
          label: row.name,
          isDisabled: row.deleted_at !== null,
        })),

    voiceOptions: [...(voices || [])]
      ?.sort((v) => (v.deleted_at === null ? -1 : 1))
      ?.map((row) => ({
        value: row._id,
        label: row.name,
        isDisabled: row.deleted_at !== null,
      })),
    genreOptions: genres?.map((row) => ({ value: row._id, label: row.name })),
    trailerOptions: types?.map((row) => ({ value: row.id, label: row.name })),
    purchaseOptions: purchaseTypes?.map((row) => ({
      value: row.id,
      label: row.name,
    })),
  };
  const [selectedMediaType, setSelectedMediaType] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [duration, setDuration] = useState(null);
  const [trailerType, setTrailerType] = useState("");
  const [fileMeta, setFileMeta] = useState({
    size: 0,
    mime_type: "",
    width: 0,
    height: 0,
  });
  const [mediaInfo, setMediaInfo] = useState({
    size: 0,
    mime_type: "",
    width: null,
    height: null,
  });
  const {
    control,
    handleSubmit,
    setError,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(route !== "edit" ? mediaSchema : mediaUpdateSchema),
  });

  useEffect(() => {
    dispatch(getAuthorList({ pageCount: 1, limit: 100 }));
    dispatch(getVoiceList({ pageCount: 1, limit: 100 }));
    dispatch(getGenreList({ pageCount: 1, limit: 100 }));
  }, []);

  useEffect(() => {
    if (route === "add") {
      async function fetchCount() {
        const count = await getMediaCount();
        setValue("sorting", count + 1);
      }
      fetchCount();
    }
  }, [setValue]);

  useEffect(() => {
    if (route !== "add") {
      dispatch(getMedia(mediaId));
    }
  }, [mediaId, dispatch, route]);

  useEffect(() => {
    if (success) {
      navigate(`/medias?current_page=${pageQuery}`);
      dispatch(resetState());
    }
  }, [success, dispatch, navigate, successMessage, pageQuery]);

  useEffect(() => {
    if (errorMessage !== null) {
      toast.error(errorMessage?.message);
      setIsLoading(false);
      errorMessage.data.items.forEach((item) => {
        const fieldName = Object.keys(item)[0];
        const message = item[fieldName];
        setError(fieldName, { type: "manual", message });
      });
    }
  }, [errorMessage, setError]);

  useEffect(() => {
    if (media) {
      setValue("title", media?.title);
      setValue("sorting", media?.sorting);
      setValue("description", media?.description);
      setValue("type", media?.type);
      setValue("original_author_ids", media?.original_author_ids);
      // const validAuthors = media?.original_authors?.filter(
      //   (o) => o.deleted_at === null
      // );

      // setValue("original_author_ids", validAuthors?.map((o) => o._id) || []);

      // const validVoices = media?.voices?.filter((v) => v.deleted_at === null);
      // setValue("voice_ids", validVoices?.map((v) => v._id) || []);
      setValue("voice_ids", media?.voice_ids);
      setValue("genre_ids", media?.genre_ids);
      setValue("trailer_type", media?.trailer_type);
      setValue("trailer_url", media?.trailer?.url);
      setValue("purchase_type", media?.purchase_type);
      setSelectedPurchaseType(media?.purchase_type);
      setSelectedMediaType(media?.type);
      setValue("cost", media?.cost);
    }
  }, [media, setValue]);

  const handleFileChange = (file, onChange) => {
    if (!file) return;

    const url = URL.createObjectURL(file);
    const isVideo = file.type.startsWith("video");
    const mediaElement = document.createElement(isVideo ? "video" : "audio");

    const maxDurationInSeconds = isVideo ? 600 : 7200;
    const maxFileSizeInBytes = isVideo ? 1000 * 1024 * 1024 : 200 * 1024 * 1024;

    if (file.size > maxFileSizeInBytes) {
      onChange(null);
      setUploadError(
        `The uploaded file exceeds the maximum size of ${isVideo ? "1000 MB" : "200 MB"
        }.`
      );

      return;
    }

    if (file.type.split("/")[1] === "mp4") {

      setTrailerType(2);

    } else {
      setTrailerType(1);
    }

    mediaElement.src = url;
    mediaElement.onloadedmetadata = () => {
      const durationInSeconds = Math.floor(mediaElement.duration);

      setMediaInfo({
        size: file.size,
        mime_type: file.type,
        width: mediaElement.videoWidth || null,
        height: mediaElement.videoHeight || null,
      });

      if (durationInSeconds > maxDurationInSeconds) {
        setUploadError(
          `The uploaded file exceeds the maximum duration of ${isVideo ? "10 minutes" : "120 minutes"
          }.`
        );
        setDuration(null);
        onChange(null);
      } else {
        setUploadError(null);
        setDuration(durationInSeconds);
        onChange(file);
      }

      URL.revokeObjectURL(url); // Clean up the URL object
    };

    mediaElement.onerror = () => {
      console.error("Error loading media file");
      setUploadError("Error loading media file.");
      URL.revokeObjectURL(url); // Clean up the URL object
    };
  };

  const onSubmit = async (data) => {
    const hasValidFormRows = data.formRows.every((row) => {
      return (
        row.sorting !== null &&
        row.sorting !== "" &&
        row.name !== "" &&
        row.media.url !== null &&
        row.media.type !== "" &&
        row.media.size !== null &&
        row.duration !== null &&
        row.media_type !== ""
      );
    });

    if (!hasValidFormRows) {
      data.formRows = [];
    }

    const hasValidSorting = data.formRows.some((row) => row.sorting !== "");
    if (selectedPurchaseType === 3) {
      const hasValidDescription = data.formRows2.some(
        (row) => row.content !== ""
      );

      if (!hasValidDescription) {
        toast.error("Description is required");
        data.formRows2 = []; // Set formRows to an empty array
      }
    }

    if (!hasValidSorting) {
      data.formRows = []; // Set formRows to an empty array
    }

    setIsLoading(true);
    try {
      let tempUrl = { image: "", trailer: "" };
      if (data.imageUpload) {
        const generatePresignedUrl = await handleMediaUpload(data.imageUpload);
        if (generatePresignedUrl.imageTemp) {
          tempUrl.image = generatePresignedUrl.imageTemp;
        } else {
          //show error message
          setIsLoading(false);
          // hide loader or enable button
        }
      }

      if (data.mediaUpload) {
        const generatePresignedUrl = await handleMediaUpload(data.mediaUpload);
        if (generatePresignedUrl.imageTemp) {
          tempUrl.trailer = generatePresignedUrl.imageTemp;
        } else {
          //show error message
          setIsLoading(false);
          // hide loader or enable button
        }
      }

      for (let i = 0; i < data.formRows.length; i++) {
        const formRow = data.formRows[i];

        if (formRow.media?.url) {
          if (formRow.media?.url instanceof File) {
            const generatePresignedUrl = await handleMediaUpload(
              formRow.media?.url
            );

            // Update image_url in the formRows array at the same index
            if (generatePresignedUrl.imageTemp) {
              formRow.media.url = generatePresignedUrl.imageTemp;
            } else {
              // Handle error scenario if needed
              toast.error("Failed to upload image for form row:", i);
            }
          }
        }
      }

      if (route !== "edit") {
        const formattedData = {
          ...data,
          sorting: parseInt(data.sorting),
          type: parseInt(data.type),
          duration: duration,
          thumbnail: {
            image_url: tempUrl.image,
            size: fileMeta.size,
            mime_type: fileMeta.mime_type,
            width: fileMeta.width,
            height: fileMeta.height,
          },
          trailer: {
            url: tempUrl.trailer,
            ...mediaInfo,
          },
          purchase_type: parseInt(data.purchase_type),
          trailer_type: trailerType,
          cost: selectedPurchaseType === 3 ? parseInt(data.cost) : null,
          items: data.formRows,
          payment_description: selectedPurchaseType === 3 ? data.formRows2 : [],
        };
        saveMediaForm(formattedData);
      } else {
        const formattedData = {
          ...data,
          sorting: parseInt(data.sorting),
          type: parseInt(data.type),
          duration: parseInt(data.duration),
          trailer_type: trailerType ? trailerType : parseInt(data.trailer_type),
          thumbnail:
            fileMeta.size === 0
              ? media?.thumbnail
              : {
                image_url: tempUrl.image,
                size: fileMeta.size,
                mime_type: fileMeta.mime_type,
                width: fileMeta.width,
                height: fileMeta.height,
              },
          items: data.formRows || [],
          trailer:
            tempUrl.trailer === ""
              ? media?.trailer
              : {
                url: tempUrl.trailer,
                ...mediaInfo,
              },
          purchase_type: parseInt(data.purchase_type),
          payment_description: selectedPurchaseType === 3 ? data.formRows2 : [],
          cost: selectedPurchaseType === 3 ? parseInt(data.cost) : null,
        };
        console.log(formattedData, "formattedData");
        saveMediaForm(formattedData, mediaId);
      }
    } catch (error) {
      toast.error("Error during form submission:", error);
      // Handle error state if needed
    } finally {
      setIsLoading(false);
    }
  };

  const handleMediaUpload = async (file) => {
    const fileExtension = {
      extensions: [file?.name.split(".").pop()?.toLowerCase()],
    };

    try {
      const response = await Client(
        API_METHOD.POST,
        url.presigned_url,
        fileExtension
      );
      const presignedUrl = response.data.data.items[0].preSignedUrl;

      const imageTemp = response.data.data.items[0].fileName;

      const saveImage = await fetch(presignedUrl, {
        method: "PUT",
        body: file,
        redirect: "follow",
      });
      if (saveImage.status === 200) {
        return { imageTemp };
      } else {
        return { type: "error", message: "Failed to Upload Image" };
      }
    } catch (error) {
      return { type: "error", message: "Failed to Upload Image" };
    }
  };

  const saveMediaForm = (formattedData, mediaId = "") => {
    if (mediaId) {
      dispatch(editMedia({ id: mediaId, data: formattedData }));
    } else {
      dispatch(addMedia(formattedData));
    }
  };
  const handleImageFileChange = (file) => {
    if (file) {
      const img = new Image();
      img.onload = () => {
        setFileMeta({
          size: file.size / 1024, // size in KB
          mime_type: file.type,
          width: img.width,
          height: img.height,
        });
      };

      img.src = URL.createObjectURL(file);
    } else {
      setFileMeta({
        size: 0,
        mime_type: "",
        width: 0,
        height: 0,
      });
    }
  };
  const handleInputChange = (event, field) => {
    const { value } = event.target;
    const formattedValue = value.replace(/\D/g, "");
    setValue(field, formattedValue);
  };

  const getCustomStyles = (field) => ({
    multiValueRemove: (base, state) => {
      return state.data.isDisabled ? { ...base, display: "none" } : base;
    },

    control: (provided, state) => ({
      ...provided,
      borderColor: errors[field] ? "red" : provided.borderColor,
      boxShadow: "none",
      maxHeight: "200px", // Set maximum height for the dropdown menu
      overflowY: "auto", // Enable vertical scrolling
      "&:hover": {
        borderColor: errors[field] ? "red" : provided.borderColor,
        boxShadow: "none",
        maxHeight: "200px", // Set maximum height for the dropdown menu
        overflowY: "auto", // Enable vertical scrolling
      },
    }),
  });

  const handleViewImage = async (imageUrlOrId) => {
    console.log(imageUrlOrId, "imageUrlOrId");

    const isImageUrl = /\.(jpg|jpeg|png|gif|webp)$/i.test(imageUrlOrId);

    let finalImageUrl = imageUrlOrId;

    if (!isImageUrl) {
      try {
        const response = await dispatch(getPresignedUrl(imageUrlOrId)).unwrap();
        finalImageUrl = response.data.item.download_url;
      } catch (error) {
        console.error("Error fetching presigned URL:", error);
        return;
      }
    }

    const currentParams = new URLSearchParams(location.search);
    setViewImageUrl(finalImageUrl);
    setViewModel(true);

    navigate(`${location.pathname}?${currentParams.toString()}`, {
      state: { viewModel: true },
    });
  };


  const handleMediaContent = (id) => {
    navigate(`/contents?id=${id}`);
  };

  return (
    <div className="page-content">
      {loading ? (
        <Spinners />
      ) : (
        <>
          {viewModel && (
            <ViewModal
              show={viewModel}
              onCloseClick={() => setViewModel(false)}
              data={viewImageUrl || ""}
            />
          )}

          <ToastContainer autoClose={2000} />
          <Card>
            <CardBody className="text-start">
              <CardTitle className="mb-4 my-3">
                {route === "edit"
                  ? "Edit Media"
                  : route === "view"
                    ? "View Media"
                    : "Create Media"}
              </CardTitle>
              <FormProvider {...{ control, handleSubmit, setValue, errors }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="Sorting" isRequired>
                          Sorting
                        </CustomLabel>
                        <Controller
                          name="sorting"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div>
                              <Input
                                {...field}
                                placeholder="Sorting"
                                invalid={!!errors.sorting}
                                maxLength={PHONE_NUMBER_MAXLENGTH}
                                onChange={(e) =>
                                  handleInputChange(e, "sorting")
                                }
                              />
                              {errors.sorting && (
                                <FormFeedback>
                                  {errors.sorting.message}
                                </FormFeedback>
                              )}
                            </div>
                          )}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="Media Title" isRequired>
                          Media Title
                        </CustomLabel>
                        <Controller
                          name="title"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div>
                              <Input
                                {...field}
                                placeholder="Enter Media Title"
                                invalid={!!errors.title}
                                // value={country?.name??""}
                                maxLength={NAME_MAXLENGTH}
                              />
                              {errors.title && (
                                <FormFeedback>
                                  {errors.title.message}
                                </FormFeedback>
                              )}
                            </div>
                          )}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="Description" isRequired>
                          Description
                        </CustomLabel>
                        <Controller
                          name="description"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <div>
                              <Input
                                {...field}
                                placeholder="Enter Description"
                                invalid={!!errors.description}
                                // value={country?.name??""}
                                maxLength={DESCRIPTION_MAXLENGTH}
                              />
                              {errors.description && (
                                <FormFeedback>
                                  {errors.description.message}
                                </FormFeedback>
                              )}
                            </div>
                          )}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="Image" isRequired>
                          Thumbnail
                        </CustomLabel>
                        {route !== "add" ? (
                          <button
                            type="button"
                            className="view-button"
                            onClick={() => {
                              handleViewImage(media?.thumbnail?.image_url);
                            }}
                          >
                            View
                          </button>
                        ) : null}

                        <Controller
                          name="imageUpload"
                          control={control}
                          defaultValue={null}
                          render={({ field }) => (
                            <div>
                              <Input
                                type="file"
                                accept="image/jpeg,image/png"
                                onChange={(e) => {
                                  field.onChange(e.target.files[0]);
                                  handleImageFileChange(e.target.files[0]);
                                }}
                                invalid={!!errors.imageUpload}
                              />
                              {errors.imageUpload && (
                                <FormFeedback>
                                  {errors.imageUpload.message}
                                </FormFeedback>
                              )}
                            </div>
                          )}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="Media Type" isRequired>
                          Media Type
                        </CustomLabel>
                        <Controller
                          name="type"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <>
                              <Select
                                {...field}
                                options={options.mediaOptions}
                                placeholder="Select Media Type"
                                onChange={(selectedOption) => {
                                  field.onChange(
                                    selectedOption ? selectedOption.value : ""
                                  );
                                  setSelectedMediaType(
                                    selectedOption ? selectedOption.value : null
                                  );
                                }}
                                value={options.mediaOptions.find(
                                  (option) => option.value === field.value
                                )}
                                styles={getCustomStyles("type")}
                                isClearable
                              />
                              {errors.type && (
                                <FormFeedback className="d-block">
                                  {errors.type.message}
                                </FormFeedback>
                              )}
                            </>
                          )}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="Author Name" isRequired>
                          Author Name
                        </CustomLabel>
                        <Controller
                          name="original_author_ids"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => {
                            const groupedOptions =
                              route === "add"
                                ? [
                                  {
                                    label: "Active",
                                    options: options.authOptions.filter(
                                      (option) =>
                                        !option.isDisabled &&
                                        !option.deleted_at
                                    ),
                                  },
                                  {
                                    label: "Inactive",
                                    options: options.authOptions.filter(
                                      (option) => option.isDisabled
                                    ),
                                  },
                                ]
                                : [
                                  {
                                    label: "Active",
                                    options: options.authOptions.filter(
                                      (option) =>
                                        !option.isDisabled &&
                                        !option.deleted_at
                                    ),
                                  },
                                  {
                                    label: "Inactive",
                                    options: options.authOptions.filter(
                                      (option) => option.isDisabled
                                    ),
                                  },
                                ];

                            return (
                              <>
                                <Select
                                  {...field}
                                  options={groupedOptions} // Use groupedOptions here
                                  placeholder="Select Author Name"
                                  isMulti
                                  onChange={(selectedOptions) =>
                                    field.onChange(
                                      selectedOptions
                                        ? selectedOptions.map(
                                          (option) => option.value
                                        )
                                        : []
                                    )
                                  }
                                  value={options.authOptions.filter((option) =>
                                    field.value.includes(option.value)
                                  )}
                                  styles={getCustomStyles(
                                    "original_author_ids"
                                  )}
                                  isClearable={
                                    groupedOptions[0].options.length > 0
                                  }
                                  menuPlacement="auto"
                                  menuShouldScrollIntoView={true}
                                  minMenuHeight={150}
                                  maxMenuHeight={150}
                                  isMenuScrollable={true}
                                />
                                {errors.original_author_ids && (
                                  <FormFeedback className="d-block">
                                    {errors.original_author_ids.message}
                                  </FormFeedback>
                                )}
                              </>
                            );
                          }}
                        />
                      </FormGroup>

                      {/* <FormGroup>
                        <CustomLabel htmlFor="Author Name" isRequired>
                          Author Name
                        </CustomLabel>
                        <Controller
                          name="original_author_ids"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => (
                            <>
                              <Select
                                {...field}
                                options={options.authOptions}
                                placeholder="Select Author Name"
                                isMulti
                                onChange={(selectedOptions) =>
                                  field.onChange(
                                    selectedOptions
                                      ? selectedOptions.map(
                                          (option) => option.value
                                        )
                                      : []
                                  )
                                }
                                value={options.authOptions.filter((option) =>
                                  field.value.includes(option.value)
                                )}
                                styles={getCustomStyles("original_author_ids")}
                                isClearable
                                menuPlacement="auto"
                                menuShouldScrollIntoView={true}
                                minMenuHeight={150}
                                maxMenuHeight={150}
                                isMenuScrollable={true}
                              />
                              {errors.original_author_ids && (
                                <FormFeedback className="d-block">
                                  {errors.original_author_ids.message}
                                </FormFeedback>
                              )}
                            </>
                          )}
                        />
                      </FormGroup> */}

                      {/* <FormGroup>
                        <CustomLabel htmlFor="Author Name" isRequired>
                          Author Name
                        </CustomLabel>
                        <Controller
                          name="original_author_ids"
                          control={control}
                          defaultValue={[]} // Default value as an empty array
                          render={({ field }) => {
                            // Filter out deleted authors from the field's value (selected authors)
                            const filteredValue = field.value.filter(
                              (selectedId) =>
                                authors.find((a) => a._id === selectedId)
                                  ?.deleted_at === null
                            );

                            return (
                              <>
                                <Select
                                  {...field}
                                  options={options.authOptions} // Active and disabled options
                                  placeholder="Select Author Name"
                                  isMulti
                                  onChange={(selectedOptions) =>
                                    field.onChange(
                                      (selectedOptions || [])
                                        .filter(
                                          (option) =>
                                            authors.find(
                                              (a) => a._id === option.value
                                            )?.deleted_at === null
                                        )
                                        .map((option) => option.value)
                                    )
                                  }
                                  value={options.authOptions.filter((option) =>
                                    filteredValue.includes(option.value)
                                  )}
                                  styles={getCustomStyles(
                                    "original_author_ids"
                                  )}
                                  isClearable
                                  menuPlacement="auto"
                                  minMenuHeight={150}
                                  maxMenuHeight={150}
                                  isMenuScrollable
                                />
                                {errors.original_author_ids && (
                                  <FormFeedback className="d-block">
                                    {errors.original_author_ids.message}
                                  </FormFeedback>
                                )}
                              </>
                            );
                          }}
                        />
                      </FormGroup> */}
                      {/* <FormGroup>
                        <CustomLabel htmlFor="Author Name" isRequired>
                          Author Name
                        </CustomLabel>
                        <Controller
                          name="original_author_ids"
                          control={control}
                          defaultValue={[]} // Default value as an empty array
                          render={({ field }) => {
                            // Get currently valid author IDs based on the current state
                            const filteredValue = field.value.filter(
                              (selectedId) =>
                                authors.find((a) => a._id === selectedId)
                                  ?.deleted_at === null
                            );

                            return (
                              <>
                                <Select
                                  {...field}
                                  options={options.authOptions} // Active and disabled options
                                  placeholder="Select Author Name"
                                  isMulti
                                  onChange={(selectedOptions) => {
                                    // Filter out deleted authors from the selected options
                                    const newValue = (selectedOptions || [])
                                      .filter(
                                        (option) =>
                                          authors.find(
                                            (a) => a._id === option.value
                                          )?.deleted_at === null
                                      )
                                      .map((option) => option.value);

                                    // If no valid authors are selected, set to empty array
                                    if (newValue.length === 0) {
                                      field.onChange([]); // Pass an empty array
                                    } else {
                                      // Update the field with the valid author IDs
                                      field.onChange(newValue);
                                    }
                                  }}
                                  value={options.authOptions.filter((option) =>
                                    {console.log(option,"option")
                                      console.log(filteredValue,"new")
                                      if(!option.isDisabled) return filteredValue.includes(option.value ) }
                                  )}
                                  
                                  styles={getCustomStyles(
                                    "original_author_ids"
                                  )}
                                  isClearable
                                  menuPlacement="auto"
                                  minMenuHeight={150}
                                  maxMenuHeight={150}
                                  isMenuScrollable
                                />
                                {errors.original_author_ids && (
                                  <FormFeedback className="d-block">
                                    {errors.original_author_ids.message}
                                  </FormFeedback>
                                )}
                              </>
                            );
                          }}
                        />
                      </FormGroup> */}

                      {/* <FormGroup>
                        <CustomLabel htmlFor="Author Name" isRequired>
                          Author Name
                        </CustomLabel>
                        <Controller
                          name="original_author_ids"
                          control={control}
                          defaultValue={[]} 
                          render={({ field }) => {
             
                            const validAuthors = authors
                              .filter((a) => a.deleted_at === null)
                              .map((a) => a._id);
                            const filteredValue = field.value.filter(
                              (selectedId) => validAuthors.includes(selectedId)
                            );

                            const handleChange = (selectedOptions) => {
                              const newValue = (selectedOptions || [])
                                .map((option) => option.value)
                                .filter((value) =>
                                  validAuthors.includes(value)
                                );
                              field.onChange(
                                newValue.length > 0 ? newValue : []
                              );
                            };

                            return (
                              <>
                                <Select
                                  {...field}
                                  options={
                                  route === "add"
                                      ? options.authOptions.filter(
                                          (option) => !option.isDisabled
                                        )
                                      : options.authOptions 
                                  }
                                  placeholder="Select Author Name"
                                  isMulti
                                  onChange={handleChange}
                                  value={options.authOptions.filter(
                                    (option) =>
                                      !option.isDisabled &&
                                      filteredValue.includes(option.value)
                                  )}
                                  styles={getCustomStyles(
                                    "original_author_ids"
                                  )}
                                  isClearable
                                  menuPlacement="auto"
                                  minMenuHeight={150}
                                  maxMenuHeight={150}
                                  isMenuScrollable
                                />
                                {errors.original_author_ids && (
                                  <FormFeedback className="d-block">
                                    {errors.original_author_ids.message}
                                  </FormFeedback>
                                )}
                              </>
                            );
                          }}
                        />
                      </FormGroup> */}

                      {/* <FormGroup>
                          <CustomLabel htmlFor="Author Name" isRequired>
                            Author Name
                          </CustomLabel>
                          <Controller
                            name="original_author_ids"
                            control={control}
                            defaultValue={[]}
                            render={({ field }) => {
                              // Filter valid authors that are not deleted
                              const validAuthors = authors.filter(
                                (a) => a.deleted_at === null
                              );
                              const validAuthorIds = validAuthors.map(
                                (a) => a._id
                              );

                              // Filter the selected value to only include valid authors
                              const filteredValue = field.value.filter(
                                (selectedId) =>
                                  validAuthorIds.includes(selectedId)
                              );

                              const handleChange = (selectedOptions) => {
                                const newValue = (selectedOptions || [])
                                  .map((option) => option.value)
                                  .filter((value) =>
                                    validAuthorIds.includes(value)
                                  );
                                field.onChange(
                                  newValue.length > 0 ? newValue : []
                                );
                              };
                              const groupedOptions = [
                                {
                                  label: "Active",
                                  options: options.authOptions.filter(
                                    (option) => !option.isDisabled && !option.deleted_at
                                  ),
                                },
                                {
                                  label: "Inactive",
                                  options: options.authOptions.filter(
                                    (option) => !option.isDisabled && option.deleted_at
                                  ),
                                },
                              ];
                              return (
                                <>
                                  <Select
                                    {...field}
                                    options={
                                      groupedOptions
                                      // route === "add"
                                      //   ? options.authOptions.filter(
                                      //       (option) => !option.isDisabled
                                      //     )
                                      //   : options.authOptions
                                    }
                                    placeholder="Select Author Name"
                                    isMulti
                                    onChange={handleChange}
                                    value={options.authOptions.filter(
                                      (option) =>
                                        !option.isDisabled &&
                                        filteredValue.includes(option.value)
                                    )}
                                    styles={getCustomStyles(
                                      "original_author_ids"
                                    )}
                                    isClearable
                                    menuPlacement="auto"
                                    minMenuHeight={150}
                                    maxMenuHeight={150}
                                    isMenuScrollable
                                  />
                                  {errors.original_author_ids && (
                                    <FormFeedback className="d-block">
                                      {errors.original_author_ids.message}
                                    </FormFeedback>
                                  )}
                                </>
                              );
                            }}
                          />
                        </FormGroup> */}
                      {/* <FormGroup>
                        <CustomLabel htmlFor="Author Name" isRequired>
                          Author Name
                        </CustomLabel>
                        <Controller
                          name="original_author_ids"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => {
                            // Filter valid authors that are not deleted
                            const validAuthors = authors.filter(
                              (a) => a.deleted_at === null
                            );
                            const validAuthorIds = validAuthors.map(
                              (a) => a._id
                            );

                            // Filter the selected value to only include valid authors
                            const filteredValue = field.value.filter(
                              (selectedId) =>
                                validAuthorIds.includes(selectedId)
                            );

                            const handleChange = (selectedOptions) => {
                              const newValue = (selectedOptions || [])
                                .map((option) => option.value)
                                .filter((value) =>
                                  validAuthorIds.includes(value)
                                );
                              field.onChange(
                                newValue.length > 0 ? newValue : []
                              );
                            };

                            return (
                              <>
                                <Select
                                  {...field}
                                  options={
                                    route === "add"
                                      ? options.authOptions.filter(
                                          (option) => !option.isDisabled
                                        )
                                      : options.authOptions.filter((option) =>
                                          validAuthorIds.includes(option.value)
                                        ) // Only show valid authors
                                  }
                                  placeholder="Select Author Name"
                                  isMulti
                                  onChange={handleChange}
                                  value={options.authOptions.filter(
                                    (option) =>
                                      !option.isDisabled &&
                                      filteredValue.includes(option.value)
                                  )}
                                  styles={getCustomStyles(
                                    "original_author_ids"
                                  )}
                                  isClearable
                                  menuPlacement="auto"
                                  minMenuHeight={150}
                                  maxMenuHeight={150}
                                  isMenuScrollable
                                />
                                {errors.original_author_ids && (
                                  <FormFeedback className="d-block">
                                    {errors.original_author_ids.message}
                                  </FormFeedback>
                                )}
                              </>
                            );
                          }}
                        />
                      </FormGroup> */}

                      {/* <FormGroup>
                        <CustomLabel htmlFor="Author Name" isRequired>
                          Author Name
                        </CustomLabel>
                        <Controller
                          name="original_author_ids"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => {
                            // Filter valid authors that are not deleted
                            const validAuthors = authors.filter(
                              (a) => a.deleted_at === null
                            );
                            const validAuthorIds = validAuthors.map(
                              (a) => a._id
                            );

                            // Filter the selected value to only include valid authors
                            const filteredValue = field.value.filter(
                              (selectedId) =>
                                validAuthorIds.includes(selectedId)
                            );

                            const handleChange = (selectedOptions) => {
                              const newValue = (selectedOptions || [])
                                .map((option) => option.value)
                                .filter((value) =>
                                  validAuthorIds.includes(value)
                                );
                              field.onChange(
                                newValue.length > 0 ? newValue : []
                              );
                            };

                            // Group options based on the route
                            const groupedOptions =
                              route === "add"
                                ? [
                                    {
                                      label: "Active",
                                      options: options.authOptions.filter(
                                        (option) =>
                                          !option.isDisabled &&
                                          !option.deleted_at
                                      ),
                                    },
                                  ]
                                : [
                                    {
                                      label: "Active",
                                      options: options.authOptions.filter(
                                        (option) =>
                                          !option.isDisabled &&
                                          !option.deleted_at
                                      ),
                                    },
                                    {
                                      label: "Inactive",
                                      options: options.authOptions.filter(
                                        (option) => option.isDisabled
                                      ),
                                    },
                                  ];

                            return (
                              <>
                                <Select
                                  {...field}
                                  options={groupedOptions}
                                  placeholder="Select Author Name"
                                  isMulti
                                  onChange={handleChange}
                                  value={options.authOptions.filter(
                                    (option) =>
                                      !option.isDisabled &&
                                      filteredValue.includes(option.value)
                                  )}
                                  styles={getCustomStyles(
                                    "original_author_ids"
                                  )}
                                  isClearable
                                  menuPlacement="auto"
                                  minMenuHeight={150}
                                  maxMenuHeight={150}
                                  isMenuScrollable
                                />
                                {errors.original_author_ids && (
                                  <FormFeedback className="d-block">
                                    {errors.original_author_ids.message}
                                  </FormFeedback>
                                )}
                              </>
                            );
                          }}
                        />
                      </FormGroup> */}
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      {/* <FormGroup>
                        <CustomLabel htmlFor="Voice Name" isRequired>
                          Voice Name
                        </CustomLabel>
                        <Controller
                          name="voice_ids"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => (
                            <>
                              <Select
                                {...field}
                                options={options.voiceOptions}
                                placeholder="Select Voice Name"
                                isMulti
                                onChange={(selectedOptions) =>
                                  field.onChange(
                                    selectedOptions.map(
                                      (option) => option.value
                                    )
                                  )
                                }
                                value={options.voiceOptions.filter((option) =>
                                  field.value.includes(option.value)
                                )}
                                styles={getCustomStyles("voice_ids")}
                                isClearable
                                menuPlacement="auto"
                                menuShouldScrollIntoView={true}
                                minMenuHeight={150}
                                maxMenuHeight={150}
                                isMenuScrollable={true}
                              />
                              {errors.voice_ids && (
                                <FormFeedback className="d-block">
                                  {errors.voice_ids.message}
                                </FormFeedback>
                              )}
                            </>
                          )}
                        />
                      </FormGroup> */}

                      {/* <FormGroup>
                        <CustomLabel htmlFor="Voice Name" isRequired>
                          Voice Name
                        </CustomLabel>
                        <Controller
                          name="voice_ids"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => {
                            // Filter valid voices that are not deleted
                            const validVoices = voices.filter(
                              (v) => v.deleted_at === null
                            );
                            const validVoiceIds = validVoices.map((v) => v._id);

                            // Filter the selected value to only include valid voices
                            const filteredValue = field.value.filter(
                              (selectedId) => validVoiceIds.includes(selectedId)
                            );

                            const handleChange = (selectedOptions) => {
                              const newValue = (selectedOptions || [])
                                .map((option) => option.value)
                                .filter((value) =>
                                  validVoiceIds.includes(value)
                                );
                              field.onChange(
                                newValue.length > 0 ? newValue : []
                              );
                            };

                            // Group options based on the route
                            const groupedOptions =
                              route === "add"
                                ? [
                                    {
                                      label: "Active",
                                      options: options.voiceOptions.filter(
                                        (option) =>
                                          !option.isDisabled &&
                                          !option.deleted_at
                                      ),
                                    },
                                  ]
                                : [
                                    {
                                      label: "Active",
                                      options: options.voiceOptions.filter(
                                        (option) =>
                                          !option.isDisabled &&
                                          !option.deleted_at
                                      ),
                                    },
                                    {
                                      label: "Inactive",
                                      options: options.voiceOptions.filter(
                                        (option) => option.isDisabled
                                      ),
                                    },
                                  ];

                            return (
                              <>
                                <Select
                                  {...field}
                                  options={groupedOptions}
                                  placeholder="Select Voice Name"
                                  isMulti
                                  onChange={handleChange}
                                  value={options.voiceOptions.filter(
                                    (option) =>
                                      !option.isDisabled &&
                                      filteredValue.includes(option.value)
                                  )}
                                  styles={getCustomStyles("voice_ids")}
                                  isClearable
                                  menuPlacement="auto"
                                  minMenuHeight={150}
                                  maxMenuHeight={150}
                                  isMenuScrollable
                                />
                                {errors.voice_ids && (
                                  <FormFeedback className="d-block">
                                    {errors.voice_ids.message}
                                  </FormFeedback>
                                )}
                              </>
                            );
                          }}
                        />
                      </FormGroup> */}

                      <FormGroup>
                        <CustomLabel htmlFor="Voice Name" isRequired>
                          Voice Name
                        </CustomLabel>
                        <Controller
                          name="voice_ids"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => {
                            const groupedOptions =
                              route === "add"
                                ? [
                                  {
                                    label: "Active",
                                    options: options.voiceOptions.filter(
                                      (option) =>
                                        !option.isDisabled &&
                                        !option.deleted_at
                                    ),
                                  },
                                ]
                                : [
                                  {
                                    label: "Active",
                                    options: options.voiceOptions.filter(
                                      (option) =>
                                        !option.isDisabled &&
                                        !option.deleted_at
                                    ),
                                  },
                                  {
                                    label: "Inactive",
                                    options: options.voiceOptions.filter(
                                      (option) => option.isDisabled
                                    ),
                                  },
                                ];

                            return (
                              <>
                                <Select
                                  {...field}
                                  options={groupedOptions}
                                  placeholder="Select Voice Name"
                                  isMulti
                                  onChange={(selectedOptions) =>
                                    field.onChange(
                                      selectedOptions
                                        ? selectedOptions.map(
                                          (option) => option.value
                                        )
                                        : []
                                    )
                                  }
                                  value={options.voiceOptions.filter((option) =>
                                    field.value.includes(option.value)
                                  )}
                                  styles={getCustomStyles("voice_ids")}
                                  isClearable={
                                    groupedOptions[0].options.length > 0
                                  }
                                  menuPlacement="auto"
                                  minMenuHeight={150}
                                  maxMenuHeight={150}
                                  isMenuScrollable
                                />
                                {errors.voice_ids && (
                                  <FormFeedback className="d-block">
                                    {errors.voice_ids.message}
                                  </FormFeedback>
                                )}
                              </>
                            );
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="Genre Name" isRequired>
                          Genre Name
                        </CustomLabel>
                        <Controller
                          name="genre_ids"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => (
                            <>
                              <Select
                                {...field}
                                options={options.genreOptions}
                                placeholder="Select Genre Name"
                                isMulti
                                onChange={(selectedOptions) => {
                                  field.onChange(
                                    selectedOptions.map(
                                      (option) => option.value
                                    )
                                  );
                                }}
                                value={options.genreOptions.filter((option) =>
                                  field.value.includes(option.value)
                                )}
                                styles={getCustomStyles("genre_ids")}
                                isClearable
                                menuPlacement="auto"
                                menuShouldScrollIntoView={true}
                                minMenuHeight={150}
                                maxMenuHeight={150}
                                isMenuScrollable={true}
                              />
                              {errors.genre_ids && (
                                <FormFeedback className="d-block">
                                  {errors.genre_ids.message}
                                </FormFeedback>
                              )}
                            </>
                          )}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="purchase_type" isRequired>
                          Purchase Type
                        </CustomLabel>
                        <Controller
                          name="purchase_type"
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <>
                              <Select
                                {...field}
                                options={options.purchaseOptions}
                                placeholder="Select Purchase Type"
                                onChange={(selectedOption) => {
                                  field.onChange(
                                    selectedOption ? selectedOption.value : ""
                                  );
                                  setSelectedPurchaseType(
                                    selectedOption ? selectedOption.value : null
                                  );
                                }}
                                value={options.purchaseOptions.find(
                                  (option) => option.value === field.value
                                )}
                                styles={getCustomStyles("purchase_type")}
                                isClearable
                              />
                              {errors.purchase_type && (
                                <FormFeedback className="d-block">
                                  {errors.purchase_type.message}
                                </FormFeedback>
                              )}
                            </>
                          )}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <CustomLabel htmlFor="trailer" isRequired>
                          Trailer
                        </CustomLabel>
                        {route !== "add" ? (
                          <button
                            type="button"
                            className="view-button"
                            onClick={() => {
                              handleViewImage(media?._id);
                            }}
                          >
                            View
                          </button>
                        ) : null}

                        <Controller
                          name="mediaUpload"
                          control={control}
                          defaultValue={null}
                          render={({ field }) => (
                            <div>
                              <Input
                                type="file"
                                accept="video/*,audio/*"
                                onChange={(e) =>
                                  handleFileChange(
                                    e.target.files[0],
                                    field.onChange
                                  )
                                }
                                invalid={!!errors.mediaUpload}
                              />
                              {errors.mediaUpload && (
                                <FormFeedback>
                                  {errors.mediaUpload.message}
                                </FormFeedback>
                              )}
                              {uploadError && (
                                <Alert color="danger">{uploadError}</Alert>
                              )}
                            </div>
                          )}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    {selectedPurchaseType === 3 ? (
                      <Col md={6}>
                        <FormGroup>
                          <CustomLabel htmlFor="Costs" isRequired>
                            Cost
                          </CustomLabel>
                          <Controller
                            name="cost"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                              <div>
                                <Input
                                  {...field}
                                  placeholder="Cost"
                                  invalid={!!errors.cost}
                                  maxLength={PHONE_NUMBER_MAXLENGTH}
                                  onChange={(e) => handleInputChange(e, "cost")}
                                />
                                {errors.cost && (
                                  <FormFeedback>
                                    {errors.cost.message}
                                  </FormFeedback>
                                )}
                              </div>
                            )}
                          />
                        </FormGroup>
                      </Col>
                    ) : null}
                  </Row>
                  {selectedPurchaseType === 3 ? (
                    <Row>
                      <Col md={6} mb={5}>
                        <ContentFormRepeater
                          data={media?.payment_description}
                          route={route}
                        />
                      </Col>
                    </Row>
                  ) : null}
                  <Row>
                    {route !== "add" ? (
                      <h4 className="py-2">
                        {selectedMediaType === 1 ? "Episodes" : "Chapters"}
                      </h4>
                    ) : (
                      <h4 className="py-2">Episodes/Chapters</h4>
                    )}
                    <Col md={12}>
                      <EpisodeForm
                        data={media?.contents || []}
                        route={route}
                        selectedPurchaseType={selectedPurchaseType}
                      />
                    </Col>
                  </Row>
                  {route === "edit" ? (
                    <Contents
                      mediaId={mediaId}
                      mediaCurrentpage={pageQuery}
                      type={selectedMediaType}
                    />
                  ) : null}
                  <Row>
                    <Col md={6}></Col>
                    <Col md={6}>
                      <div className="d-flex justify-content-end gap-2">
                        <Button
                          type="button"
                          color="secondary"
                          onClick={() => {
                            navigate(`/medias?current_page=${pageQuery}`);
                            dispatch(resetError());
                          }}
                        >
                          {route === "view" ? "Back" : "Cancel"}
                        </Button>
                        {route !== "view" ? (
                          <Button
                            type="submit"
                            className={isLoading ? "disabled" : ""}
                            color={isLoading ? "success" : "primary"}
                          >
                            {isLoading ? (
                              <>Loading...</>
                            ) : (
                              <>
                                {route === "edit"
                                  ? "Edit Media"
                                  : "Create Media"}
                              </>
                            )}
                          </Button>
                        ) : null}
                      </div>
                    </Col>
                  </Row>
                </form>
              </FormProvider>
            </CardBody>
          </Card>
        </>
      )}
    </div>
  );
};

export default AddMedia;
